module.exports = {
	"articleTitle1": "Q&A with Knight News football writer Tyler Graddy ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Knight's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/mens-tennis/wolverines-cruise-victory-against-princeton",
	"articleSnippet1": "Sep 9, 2016 ... Football writer Tyler Graddy from UCF's student newspaper, Knight News, took \nsome time to shed insight on Michigan's unfamiliar opponent ...",
	"articleSnippet2": "Feb 2, 2017 ... Junior Alex Knight clinched the final set for the 18th-ranked Wolverines to give \nMichigan (3-1) a dominant 6-1 victory.",
	"foodRecommendations": [],
	"articleTitle2": "Wolverines cruise to victory against Princeton ",
	"address": "600 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279241,
		"lng": -83.741848
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/knights.json
// module id = 902
// module chunks = 0